import React, { Component } from 'react';
import { connect } from 'react-redux';

import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('PRODUCTS', LOG_LEVELS.ERROR);

class Products extends Component {

  render() {
    log.debug('render(): ', this.props);
    if (!this.props.hideMatches) {
      if (this.props.greyMatches) {
        return(<span className='disable'>{this.props.children}</span>);
      }

      if (this.props.showMatches) {
        return(this.props.children);
      }
    }
    return(<></>);
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state);
  let myProducts = (state.authentication && state.authentication.data && state.authentication.data.products) || [];
  log.debug('mapStateToProps: myProducts: ', myProducts);
  const hide = (props.hide && Array.isArray(props.hide) ? props.hide : [props.show]) || [];
  const grey = (props.grey && Array.isArray(props.grey) ? props.grey : [props.grey]) || [];
  const show = (props.show && Array.isArray(props.show) ? props.show : [props.show]) || [];
  const hideMatches = hide.filter((role) => {return myProducts.indexOf(role) >= 0;}).length > 0;
  const greyMatches = grey.filter((role) => {return myProducts.indexOf(role) >= 0;}).length > 0;
  const showMatches = show.length <= 0 || show.filter((role) => {return myProducts.indexOf(role) >= 0;}).length > 0;
  return {    
    hideMatches,
    greyMatches,
    showMatches,
    myProducts
  };
}

/**
 *
 * Precedence:
 * hide beats grey beats show.
 *
 */
Products.defaultProps = {
  hide: [],
  grey: [],
  show: [],
};

export default connect(mapStateToProps)(Products);
